import { useState } from 'react'
import { MERCHANT_EDITABLE_STATUSES } from 'consts'
import { useGetMerchantApplicationQuery } from 'generated/graphql'
import { ApplicationReview } from 'pages/ApplicationReview'
import { Onboarding } from 'pages/Onboarding/Onboarding'
import { OnboardingSubmitted } from 'pages/Onboarding/OnboardingSubmitted'
import { TemporaryScreen } from 'pages/Onboarding/types'

export const OnboardingWrapper = () => {
  const { data, loading } = useGetMerchantApplicationQuery()
  const [temporaryScreen, setTemporaryScreen] =
    useState<TemporaryScreen | null>(null)

  if (loading) {
    return null
  }

  if (!data?.merchantApplication) {
    throw new Error('Merchant application not found')
  }

  if (temporaryScreen === 'onboarding-submitted') {
    return <OnboardingSubmitted setTemporaryScreen={setTemporaryScreen} />
  }

  const status = data?.merchantApplication?.status

  if (status && MERCHANT_EDITABLE_STATUSES.includes(status)) {
    const usBankAccount = data.bankAccounts?.find(
      account => account.currency === 'USD' && account.bankCountry === 'US'
    )

    return (
      <Onboarding
        merchantApplication={data.merchantApplication}
        individuals={data?.nestedIndividuals?.individuals}
        bankAccounts={usBankAccount ? [usBankAccount] : []}
        entityMccs={data.entityMccs?.mccs}
        setTemporaryScreen={setTemporaryScreen}
      />
    )
  }

  return (
    <ApplicationReview
      merchantApplication={data.merchantApplication}
      individuals={data?.nestedIndividuals?.individuals}
    />
  )
}
